import DOMPurify from 'dompurify'

const tags = ['p', 'br', 'h1', 'h2', 'h3', 'strong', 'b', 'em', 'i', 'ul', 'ol', 'li', 'a', 'img']
const attributes = ['href', 'src', 'alt', 'title', 'target', 'rel']

export const cleanBlogHtml = (html: string): string =>
  DOMPurify.sanitize(html, { ALLOWED_TAGS: tags, ALLOWED_ATTR: attributes })

export const imageUrlsInHtml = (html: string): string[] => {
  const container = document.createElement('div')
  container.innerHTML = cleanBlogHtml(html)
  return Array.from(container.querySelectorAll('img'))
    .map(image => image.getAttribute('src') || '')
    .filter(Boolean)
}

export const mapImageSources = (html: string, replacements: Record<string, string>): string => {
  const container = document.createElement('div')
  container.innerHTML = cleanBlogHtml(html)
  Array.from(container.querySelectorAll('img')).forEach(image => {
    const src = image.getAttribute('src') || ''
    if (replacements[src]) image.setAttribute('src', replacements[src])
  })
  return container.innerHTML
}
